var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',[_c('div',[(_vm.type == 1)?_c('engine-oil'):_vm._e(),(_vm.type == 2)?_c('transmission-oil'):_vm._e(),(_vm.type == 3)?_c('tire'):_vm._e(),(_vm.type == 4)?_c('oil-filter'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }